import React from "react";


// ITS IN $ and be hard to calculate for now.

export const handleTlgExtraction = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split('\n');
      const extractedData = formatTlgData(lines);
      resolve(extractedData);
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      reject(error);
    };
    reader.readAsText(file);
  });
};

const formatTlgData = (lines) => {
  const trades = {};
  let currentSymbol = '';

  lines.forEach(line => {
    if (line.startsWith('STK_TRD|')) {
      const [, id, symbol, , , type, , date, time, currency, price, quantity, , amount] = line.split('|');
      
      if (!trades[symbol]) {
        trades[symbol] = {
          buys: [],
          sells: [],
          totalQuantity: 0,
          totalCost: 0,
          totalRevenue: 0,
        };
      }

      const trade = {
        id,
        date: `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6)}`,
        time,
        price: parseFloat(price),
        quantity: parseInt(quantity),
        amount: parseFloat(amount),
      };

      if (type.includes('BUY')) {
        trades[symbol].buys.push(trade);
        trades[symbol].totalQuantity += trade.quantity;
        trades[symbol].totalCost += Math.abs(trade.amount);
      } else if (type.includes('SELL')) {
        trades[symbol].sells.push(trade);
        trades[symbol].totalQuantity -= trade.quantity;
        trades[symbol].totalRevenue += Math.abs(trade.amount);
      }

      currentSymbol = symbol;
    }
  });

  return Object.entries(trades).map(([symbol, data]) => {
    const profit = data.totalRevenue - data.totalCost;
    const lastTrade = [...data.buys, ...data.sells].sort((a, b) => new Date(b.date + ' ' + b.time) - new Date(a.date + ' ' + a.time))[0];

    return {
      "Id": lastTrade.id,
      "Balance": "",
      "Amount": profit.toFixed(2),
      "Currency": "USD",
      "Type": data.totalQuantity > 0 ? "BUY" : "SELL",
      "Status": "PROCESSED",
      "Modified": lastTrade.date,
      "Trade Id": lastTrade.id,
      "Instrument Symbol": symbol,
      "Instrument Name": symbol,
      "Commission": "",
      "Account type": "IBKR"
    };
  });
};

const TlgIBKRUploader = ({ onDataExtracted }) => {
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const extractedData = await handleTlgExtraction(file);
      onDataExtracted(extractedData);
    } catch (error) {
      console.error("Error processing TLG file:", error);
    }
  };

  return (
    <div>
      <input type="file" accept=".tlg" onChange={handleFileChange} />
    </div>
  );
};

export default TlgIBKRUploader;